<template>
  <ContainerBasic container-type="CONTENT">
    <VideoDetailed
      :video-data="blockData.video"
      :style="textColor"
      class="mx-auto min-h-[190px] min-w-[320px] lg:h-[540px] touch:md:h-[540px] lg:w-[960px] touch:md:w-[960px]"
  /></ContainerBasic>
</template>

<script setup lang="ts">
import VideoDetailed from './components/video-detailed.vue';
import { styledSectionTextColor } from '@/injectionSymbols';
import ContainerBasic from '@/components/components/container-basic.vue';
import type { VideoData } from './blockType';

defineProps({
  blockData: {
    type: Object as PropType<VideoData>,
    required: true,
    default: {} as VideoData,
  },
});

const textColor = inject(styledSectionTextColor, null);
</script>
